import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import {
  Box,
  Button,
  DialogActions,
  Divider,
  Link,
  Typography,
} from "@material-ui/core";

const useStyles = makeStyles({
  actions: {
    padding: 15,
  },
});

export const LegalDisclaimerMessageDialog: React.FC<{
  open: boolean;
  onClose: () => void;
}> = ({ open, onClose }) => {
  const classes = useStyles();
  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle id="legalDisclaimer-dialog-title">
        Please note the following important information which was updated
        January 2021
      </DialogTitle>
      <Divider />
      <Box p={3}>
        <Typography variant="body1" component="p">
          Where personal data is requested, awarding organisations must consider
          whether any steps need to be taken in order to ensure compliance with
          data protection legislation.
          <p></p>
          <b>
            Please note that as of 1st January 2021, the data protection laws in
            the UK have changed.
          </b>{" "}
          Where personal data is being transferred, you may need to consider
          whether you need to put in place any additional safeguards. Ofqual can
          provide assurance that it will process personal data in accordance
          with UK data protection legislation. For more details about how Ofqual
          processes personal data please see our
          <Link
            underline="always"
            target="_blank"
            href="https://www.gov.uk/government/organisations/ofqual/about/personal-information-charter"
          >
            {" "}
            privacy information
          </Link>
          <p></p>
          All information submitted in response to this request will be retained
          by Ofqual and may be used for other purposes in accordance with
          Ofqual’s objectives and duties. Personal data will only be used for
          another compatible purpose and/or anonymised or pseudonymised where
          possible.
          <p></p>
          Ofqual is subject to the Freedom of Information (FOI) Act 2000 and we
          may be asked to disclose information under that Act. No personal data
          will be disclosed unless required by law. Where an awarding
          organisation indicates that it considers information submitted to us
          to be commercially sensitive, we will take this into account when
          considering any FOI request. However, it will be for Ofqual to
          determine whether the information must be disclosed or an exemption
          applied.
          <p></p>
          Ofqual may share information with other agencies or authorities where
          appropriate or where required by law.
        </Typography>
      </Box>
      <DialogActions className={classes.actions}>
        <Button
          onClick={onClose}
          color="primary"
          data-test="close-legal-disclaimer-dialog"
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};
